import { render, staticRenderFns } from "./PDIHistory.vue?vue&type=template&id=abc99a10"
import script from "./PDIHistory.vue?vue&type=script&lang=js"
export * from "./PDIHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports